import React from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import { useAuth } from "./helpers/configs/plugins/CookieAuthPlugin";
import { IS_APP_PRODUCTION, PACKAGE_NAME } from "./helpers/environment";
import BasePage from "./view/app";
import AuthPage from "./view/auth";
import AboutUs from "./view/pages/AboutUs";
import PaymentQrPage from "./view/pages/PaymentQrPage";
import PrivacyPolicy from "./view/pages/PrivacyPolicy";
import TermsAndConditions from "./view/pages/TermsAndConditions";

export default function Routes() {
  const { user } = useAuth();
  return (
    <BrowserRouter basename={IS_APP_PRODUCTION ? `/` : PACKAGE_NAME}>
      <Switch>
        <Route path="/payment/:code" component={PaymentQrPage} />
        <Route path="/about-us" component={AboutUs} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-conditions" component={TermsAndConditions} />
        {user ? <Redirect from="/login" to="/" /> : <AuthPage />}
        {user ? <BasePage /> : <Redirect to="/login" />}
      </Switch>
    </BrowserRouter>
  );
}
